import m, { GetMemberActionTypes } from './types/memberActions';
import { MemberInfoState, SubmitterContactInfo } from './types/memberTypes';

export const defaultSubmitterContactInfoState: SubmitterContactInfo = {
  firstName: '',
  lastName: '',
  companyName: '',
  phoneNumber: '',
  emailAddress: '',
  oonAttachedForNSAClaim: '',
};

export const defaultMemberState: MemberInfoState = {
  memberDetailsLoaded: false,
  hasError: false,
  memberInfo: {
    sixdegaliasid: '',
    sfaccountid: '',
    accountid: '',
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    dateOfBirth: '',
    memberId: '',
    patientid: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    policyNumber: '',
    sixDegPatientID: '',
    planname: '',
    recordType: '',
    preferredMethodOfContact: '',
    additionalComment: '',
    groupid: '',
    tpaName: '',
    sfplanid: '',
    newPatient: false,
    submitterContactInfo: { ...defaultSubmitterContactInfoState },
  },
};

const getMemberReducer = (
  state: MemberInfoState = defaultMemberState,
  action: GetMemberActionTypes
): MemberInfoState => {
  switch (action.type) {
    case m.GET_MEMBER: {
      return {
        ...state,
      };
    }
    case m.GET_MEMBER_PENDING: {
      return {
        ...state,
        hasError: false,
      };
    }
    case m.GET_MEMBER_FULFILLED: {
      const memberInfoFromAPI = action.payload.data;

      if (action.payload) {
        return {
          ...state,
          memberInfo: {
            ...memberInfoFromAPI,
            submitterContactInfo: state.memberInfo.submitterContactInfo,
          },
          memberDetailsLoaded: true,
        };
      }

      return {
        ...state,
        memberDetailsLoaded: false,
      };
    }

    case m.GET_MEMBER_REJECTED: {
      return {
        ...state,
        hasError: true,
      };
    }

    case m.RESET_MEMBER_INFO: {
      return defaultMemberState;
    }

    default:
      return state;
  }
};

export default getMemberReducer;
